<div class="mdc-layout-grid__inner center">
	<div class="mdc-layout-grid__cell--span-12">
		<mat-icon class="large h-auto">find_in_page</mat-icon>
	</div>

	<div class="mdc-layout-grid__cell--span-12">
		<h2 id="n17">{{ locale.translations['404']['n17'] }}</h2>
	</div>

	<div class="mdc-layout-grid__cell--span-12">
		<a mat-flat-button color="primary" href="/" id="n18">{{ locale.translations['404']['n18'] }}</a>
	</div>
</div>
